export default __webpack_public_path__ + "static/media/mob-ywll.e1d850a0.svg";